import React from 'react';
import { Container, List, Icon } from 'semantic-ui-react';
import CardBackground from './CardBackground';
import uiucImg from '../images/uiuc.jpg';
import graingerImg from '../images/grainger.png';
import almaMaterImg from '../images/alma_mater.jfif';
import claudeImg from '../images/claude.png';
import codeImg from '../images/code.png';
import githubImg from '../images/github.png';
import * as REAL_EN from '../data/en';
import * as REAL_CN from '../data/cn';

const FAKE_CN = '臣本布衣躬耕于南阳苟全性命于乱世不求闻达于诸侯';
const FAKE_EN = 'Lorem ipsum dolor sit amet consectetur adipiscing elit';

function EducationSection({ educationData, lang, isPublic }) {
  const t = (cn, en) => isPublic ? (lang ? FAKE_CN : FAKE_EN) : (lang ? cn : en);
  const realEdu = lang ? REAL_CN.education : REAL_EN.education;
  // In public mode, degrees and coursework show real content; other sections use fake
  const degreesData = isPublic ? realEdu.degrees : educationData.degrees;
  const courseworkData = isPublic ? realEdu.coursework : educationData.coursework;
  const uiucBg = uiucImg;
  const researchBg = isPublic ? githubImg : graingerImg;
  const courseworkBg = almaMaterImg;
  const aiToolsBg = claudeImg;
  const skillsBg = codeImg;
  return (
    <Container text textAlign="left">
      {/* Degrees */}
      {degreesData.map((deg, idx) => {
        const parts = deg.school.split(/[,，]\s*/);
        const last = parts[parts.length - 1];
        const yearMatch = /^\d{4}([-–]\d{4})?$/.test(last);
        const year = yearMatch ? parts.pop() : null;
        const schoolName = parts.join(', ');
        const isUIUC = schoolName.includes('伊利诺伊') || schoolName.includes('Illinois');
        const bgUrl = isPublic || isUIUC ? uiucBg : null;
        return (
          <div
            key={idx}
            className={`agent-window${bgUrl ? ' agent-window--bg-image' : ''}`}
          >
            <div className="agent-window__titlebar">
              <div className="agent-window__dots">
                <span className="dot dot--green" style={{ animationDelay: `${idx * 0.5}s` }} />
              </div>
              <Icon name="graduation cap" className="agent-window__icon" />
              <h3 className="agent-window__title">
                <a href={deg.url} className="agent-window__link">{schoolName}<Icon name="external alternate" className="link-icon" /></a>
                {year && <span className="agent-window__date">{year}</span>}
              </h3>
            </div>
            <div className="agent-window__content">
              {bgUrl && <CardBackground src={bgUrl} />}
              <List as="ul">
                {(deg.details || [deg.detail]).map((d, di) => (
                  <List.Item key={di}>
                    <span className="agent-spinner" style={{ animationDelay: `${di * 0.5}s` }} />
                    <span>{d}</span>
                  </List.Item>
                ))}
              </List>
            </div>
          </div>
        );
      })}

      {/* Research */}
      <div className="agent-window agent-window--bg-image">
        <div className="agent-window__titlebar">
          <div className="agent-window__dots">
            <span className="dot dot--green" style={{ animationDelay: `${degreesData.length * 0.5}s` }} />
          </div>
          <Icon name="flask" className="agent-window__icon" />
          <h3 className="agent-window__title">{lang ? '研究' : 'Research'}</h3>
        </div>
        <div className="agent-window__content">
          <CardBackground src={researchBg} />
          <List as="ul">
            {educationData.research.map((r, idx) => (
              <List.Item key={idx}>
                <span className="agent-spinner" style={{ animationDelay: `${idx * 0.5}s` }} />
                <span><a href={r.url} className="agent-window__link">{r.label}<Icon name="external alternate" className="link-icon" /></a>: {r.text}</span>
              </List.Item>
            ))}
          </List>
        </div>
      </div>

      {/* Coursework */}
      <div className="agent-window agent-window--bg-image">
        <div className="agent-window__titlebar">
          <div className="agent-window__dots">
            <span className="dot dot--green" style={{ animationDelay: `${(degreesData.length + 1) * 0.5}s` }} />
          </div>
          <Icon name="book" className="agent-window__icon" />
          <h3 className="agent-window__title">{lang ? '课程' : 'Coursework'}</h3>
        </div>
        <div className="agent-window__content">
          <CardBackground src={courseworkBg} />
          <List as="ul">
            {courseworkData.flatMap((row, rowIdx) =>
              row.map((c, i) => {
                const globalIdx = rowIdx * row.length + i;
                return (
                  <List.Item key={globalIdx}>
                    <span className="agent-spinner" style={{ animationDelay: `${globalIdx * 0.5}s` }} />
                    <span><a href={c.url} className="agent-window__link">{c.label}</a></span>
                  </List.Item>
                );
              })
            )}
          </List>
        </div>
      </div>

      {/* AI Tools */}
      <div className="agent-window agent-window--bg-image">
        <div className="agent-window__titlebar">
          <div className="agent-window__dots">
            <span className="dot dot--green" style={{ animationDelay: `${(degreesData.length + 2) * 0.5}s` }} />
          </div>
          <Icon name="magic" className="agent-window__icon" />
          <h3 className="agent-window__title">{lang ? 'AI 工具' : 'AI Tools'}</h3>
        </div>
        <div className="agent-window__content">
          <CardBackground src={aiToolsBg} />
          <List as="ul">
            {educationData.aiTools.map((tool, idx) => (
              <List.Item key={idx}>
                <span className="agent-spinner" style={{ animationDelay: `${idx * 0.5}s` }} />
                <span>{tool}</span>
              </List.Item>
            ))}
          </List>
        </div>
      </div>

      {/* Skills */}
      <div className="agent-window agent-window--bg-image">
        <div className="agent-window__titlebar">
          <div className="agent-window__dots">
            <span className="dot dot--green" style={{ animationDelay: `${(degreesData.length + 3) * 0.5}s` }} />
          </div>
          <Icon name="code" className="agent-window__icon" />
          <h3 className="agent-window__title">{lang ? '技能' : 'Skills'}</h3>
        </div>
        <div className="agent-window__content">
          <CardBackground src={skillsBg} />
          <List as="ul">
            {educationData.skills.map((skill, idx) => (
              <List.Item key={idx}>
                <span className="agent-spinner" style={{ animationDelay: `${idx * 0.5}s` }} />
                <span>{skill}</span>
              </List.Item>
            ))}
          </List>
        </div>
      </div>
    </Container>
  );
}

export default EducationSection;
